import {ETANotificationContainer} from "./common/ETANotificationConfigs.style";
import {ETANotificationForm} from "./views/ETANotificationForm";
import {ETAEvaluationPrecedence} from "./views/ETAEvaluationPrecedence";
import {ETANotificationConfigsProvider} from "./ETANotificationConfigsProvider";

export const ETANotificationConfigView = () => {
  return (
    <ETANotificationConfigsProvider>
      <ETANotificationContainer>
        <ETANotificationForm />
        <ETAEvaluationPrecedence />
      </ETANotificationContainer>
    </ETANotificationConfigsProvider>
  );
};
